<script>
import { mapState } from 'vuex';
import {  BIconDownload,BIconPeople ,BIconChevronLeft ,BIconChevronRight,BIconBook } from 'bootstrap-vue';
import permissions from '@/mixins/permissions';
import storeHelper from '@/mixins/storeHelper';
import Users from '../Users.vue';
import agreementTitle from '@/lib/agreement-title';
import {trialActiveForClients, hasViewPermission, canViewShareAgreement, currentRoleLevelName,isClientUserAgreement} from '@/mixins/roleLevelPermissions';
import SubscriptionModal from '../SubscriptionModal.vue';

import DownloadAgreementConfirmationModal from '../DownloadAgreementConfirmationModal.vue';
import DownloadDisclaimerModal from '../DownloadDisclaimerModal.vue';

export default {
	components: {
		BIconDownload,
		BIconPeople,
		Users,
		BIconChevronLeft,
		BIconChevronRight,
		BIconBook,
		SubscriptionModal,
		DownloadAgreementConfirmationModal,
		DownloadDisclaimerModal
	},
	// props: ['clientUserAgreement'],
	props: ['isEdPanelOpen','currentRoleLevelName','showPermissionDeniedPageDisplay','agreementData'],

	computed: {
		...mapState(['agreement', 'editedAgreement', 'saving','isEditorUnresolved', 'currentRoleLevel']),
		canDownload() {
			return this.editedAgreement;
		},
		title() {
			const title =
				this.agreement && agreementTitle(this.agreement).co != 'and'
					? agreementTitle(this.agreement)
					: '';
			return title;
		},
		clientUserAgreement(){
			return this.currentRoleLevelName == 'client-sharing-user' ? true : false;
		},
		isClientUserAgreementComputed(){
			return isClientUserAgreement();
		},
		isSeparatingParty(){
			return this.currentRoleLevel?.roleAssociated === 'party';
		},
	},
	data() {
		return {
			usersVisible: false,
			activeTab:'builder',
			showSubscriptionModal: false,
			showDownloadConfirmationModal: false,
			showDisclaimerModal: false
		};
	},
	mixins: [permissions,storeHelper],
	methods: {
		hasViewPermission,
		canViewShareAgreement,
		showUsers() {
			if(trialActiveForClients()){
				this.showSubscriptionModal = true
				return
			}
			else{
				if(this.isEdPanelOpen){
					this.toggleEdPanel()
				}
				this.usersVisible = true;
			}
		},

		requestMediation() {
			window.open('https://share.hsforms.com/1e-g6n_cDQs2UZPyx55oI_wr5qai', '_blank');
		},

		download(pageToDownload) {
			// For agreement downloads by separating parties, show disclaimer first
			if (pageToDownload === 'agreement' && this.isSeparatingParty) {
				this.showDisclaimerModal = true;
				return;
			}

			// For agreement downloads by non-separating parties (lawyers, assistants), skip disclaimer
			if (pageToDownload === 'agreement' && !this.isSeparatingParty) {
				this.proceedWithDownload();
				return;
			}

			// Property schedule downloads proceed directly
			if (pageToDownload === 'property-schedule') {
				let assetView = localStorage.getItem('isAssetView');
				console.log("assetView:", assetView);
				let routeUrl = `${window.location.origin}${window.location.pathname}/preview?download=${pageToDownload}`;
				window.open(routeUrl);
			}
		},

		handleDisclaimerAccept() {
			this.showDisclaimerModal = false;
			// Proceed with existing download flow
			this.proceedWithDownload();
		},

		proceedWithDownload() {
			if (this.isEditorUnresolved) {
				this.showDownloadConfirmationModal = true;
			} else {
				let routeUrl = `${window.location.origin}${window.location.pathname}/preview`;
				window.open(routeUrl);
			}
		},
		toggleEdPanel(){
			if(trialActiveForClients()){
				this.showSubscriptionModal = true
				return
			}
			else{
				this.$emit('toggleEdPanel')
				if(this.usersVisible){
					this.usersVisible = false;
				}
			}
			
		},
		trialActiveForClients
	},
	mounted() {
		this.activeTab = this.getSessionStorageString('activeTab');
		window.addEventListener('session-storage-changed', (event) => {
			if(event.detail && event.detail.activeTab)
			this.activeTab = event.detail.activeTab;
		});

		setTimeout(() => {
			if(document.getElementById('users-sidebar') && document.getElementById('users-sidebar').children && document.getElementById('users-sidebar').children[0] && document.getElementById('users-sidebar').children[0].children  && document.getElementById('users-sidebar').children[0].children)
					document.getElementById('users-sidebar').children[0].children[0].setAttribute('data-test-id','close-share-agreement')
		}, 1000);
		
	},
};
</script>

<style>
.users-sidebar {
	top: 70px;
	overflow-y: scroll;
	max-height: calc(100vh - 70px);
	width: 400px;
}

.download-agr-btn{
	margin-left: 0.5rem;
	margin-right: 0.5rem;
}

@media only screen and (max-width: 480px) {
	.hide-mobile {
		display: none;
	}

	.title {
		/* max-width: 296px; */
		max-width: 140px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}
@media only screen and (min-width: 480px) and (max-width: 770px) {
	.hide-mobile {
		display: none;
	}

	.title {
		max-width: 270px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}

.saving-btn{
	border: 1px solid #243B42;
    /* color: #f7a91b; */
}

.b-sidebar-header{
	direction: rtl;
}

.b-sidebar.b-sidebar-right > .b-sidebar-header .close{
	margin-left: auto;
    margin-right: 0;
}

.share-btn{
	background-color: #678B95;
	border-color: #678B95;
}

.request-mediation-btn{
	background-color: #678B95 !important;
	border-color: #678B95 !important;
}
</style>

<template>
	<div class='print-hide'>
		<b-row class="mt-1" style="height: 32px">
			<b-col cols="auto">
				<h5 class="title">{{ title }}</h5>
			</b-col>
			<b-col>
				<div class="float-right">
					<b-button
						v-if="isSeparatingParty && agreementData"
						@click="requestMediation"
						size="sm"
						variant="dark-blue"
						data-testid="request-mediation"
						class="ml-2 request-mediation-btn"
					>
						<span class="hide-mobile"> Request Mediation</span>
					</b-button>
					<b-badge
						pill
						variant="light"
						class="p-2 mx-2 saving-btn"
						style="width: 64px"
						>{{ saving ? 'Saving...' : 'Saved' }}</b-badge
					>
					<!-- <b-button-group> -->
						<b-button
							@click="download(activeTab)"
							size="sm"
							variant="dark-blue"
							data-testid="download-property-schedule"
							v-if="activeTab == 'property-schedule'"
						>
							<b-icon-download />
							<span class="hide-mobile"> Download</span>
						</b-button>
						<b-button
							v-if="canDownload && !clientUserAgreement && !trialActiveForClients()"
							@click="download('agreement')"
							size="sm"
							variant="dark-blue"
							data-testid="download-agreement"
							class="download-agr-btn"
						>
							<b-icon-download />
							<span class="hide-mobile"> Download Agreement</span>
						</b-button>
						<b-button
							v-if="!clientUserAgreement && canViewShareAgreement() && agreementData"
							@click="showUsers"
							size="sm"
							variant="dark-blue"
							data-testid="share-agreement"
							class="ml-2 share-btn"
							:class="{'btn-disabled-but-clickable': trialActiveForClients()}"
						>
							<b-icon-people />
							<span class="hide-mobile"> Share</span>
						</b-button>
						
						<!-- <b-button 
							size="sm"
							variant="primary"
							class="ml-2"
							@click="toggleEdPanel"
							v-if="(currentRoleLevelName === 'client-level-1' ||currentRoleLevelName === 'client-level-2')&& !showPermissionDeniedPageDisplay && agreementData && !isClientUserAgreementComputed"
							data-testid="toggle-education-panel"
							:class="{'btn-disabled-but-clickable': trialActiveForClients()}"
						>
							<b-icon-chevron-right v-if="isEdPanelOpen"></b-icon-chevron-right>
							<b-icon-chevron-left v-else></b-icon-chevron-left>
							Learn &nbsp;
							<b-icon-book/>
						</b-button> -->
						<!-- END: Reverted educational panel changes in Release 2.1 -->
					<!-- </b-button-group> -->
				</div>
			</b-col>
		</b-row>
		<b-sidebar
			v-if="agreement && !trialActiveForClients()"
			id="users-sidebar"
			v-model="usersVisible"
			title="Share"
			right
			shadow
			sidebar-class="users-sidebar"
		>
			<users :id="agreement.id" />
		</b-sidebar>
		<subscription-modal :showSubscriptionModal="showSubscriptionModal" @close="showSubscriptionModal = false"></subscription-modal>

		<download-disclaimer-modal
			:showDisclaimerModal="showDisclaimerModal"
			@close="showDisclaimerModal = false"
			@accept="handleDisclaimerAccept"
		/>

		<download-agreement-confirmation-modal
			:showDownloadConfirmationModal="showDownloadConfirmationModal"
			:draft="false"
			@close="showDownloadConfirmationModal= false"
			:mode="'editor'"
		/>
	</div>
</template>
